<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="
                mx-auto
                col-xl-4 col-lg-5 col-md-7
                d-flex
                flex-column
                mx-lg-0
              "
            >
              <div class="card card-plain">
                <toast  position="top-center"/> 
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In</h4>
                  <p class="mb-0">Enter your email and password to sign in</p>
                </div>
                <div class="card-body">
                  <form role="form" @submit.prevent="checkSignIn">
                    <div class="mb-3">
                      <input 
                      class="input-group-text form-control"
                        type="email"
                        placeholder="Email"
                        name="email"
                        v-model="email" 
                      />
                    </div>
                    <div class="mb-3">
                      <input
                      class="input-group-text form-control"
                        type="password"
                        placeholder="Password"
                        name="password"
                        v-model="password"
                      />
                    </div>
                    <argon-switch id="rememberMe">Remember me</argon-switch>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="success"
                        fullWidth
                        size="lg"
                        >Sign in</argon-button
                      >
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="
                top-0
                my-auto
                text-center
                col-6
                d-lg-flex d-none
                h-100
                pe-0
                position-absolute
                end-0
                justify-content-center
                flex-column
              "
            >
              <div
                class="
                  position-relative
                  bg-gradient-primary
                  h-100
                  m-3
                  px-7
                  border-radius-lg
                  d-flex
                  flex-column
                  justify-content-center
                  overflow-hidden
                "
                style="
                  background-image: url('https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg');
                  background-size: cover;
                "
              >
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative fs-2"
                >
                  Jarvis Admin
                </h4>
                <p class="text-white position-relative fs-4">
                  Welcome
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Toast from 'primevue/toast';
import router from "../router";
import AdminService from './service/AdminService'
const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  components: {
    Navbar,
    ArgonSwitch,
    ArgonButton,
    Toast
  },
  data (){
    return {
      email: null ,
      password : null ,
      adminService : null
    }
  },
  props : [''],
  methods : {
    checkSignIn(){
      if( this.email && this.password){
      this.adminService.login(this.email , this.password).then((data) => {
        if(data.status_code != 200){
          this.$toast.add({
        severity: "error",
        summary: "Error",
        detail: "Invalid Data",
        life: 3000,
      });
        }
        else
        {
          localStorage.setItem('auth-token' , data.data.token)
          this.axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth-token')}`
          router.push('/dashboard');

        }
      });
    }
    },
    signUp(){
      router.push('/signup')
    }
  },
  created() {
    this.adminService = new AdminService();
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>

<style>
.bg-gradient-success{
  background-image: linear-gradient(310deg, #8093dd 0%, #7281ad 100%) !important
  }
</style>
